import React from 'react';
import { Megaphone } from 'lucide-react';

// Kayan duyuru bandının içi tek yerdedir. Klasik kabuk ile Merit aynı metni
// çizer; iki yerde ayrı ayrı yazılsaydı tekrar sayısı ya da animasyon
// süresi ayrışır ve aynı duyuru iki şemada farklı hızda kayardı.
//
// Metin iki özdeş **grup** hâlinde çizilir ve animasyon tam bir grup kadar
// kaydırır (App.css `announcement-scroll`, -%50): ikinci grup birincinin
// yerine oturduğu için döngü kapanırken zıplama olmaz. Grup içindeki kopya
// sayısı bandı doldurmak içindir — dört kopya kısa bir duyuruda geniş
// ekranın ancak yarısına yetiyor, sağ taraf hep boş kalıyordu. Yetmediği
// ölçüde grubun kendisi genişler (`.announcement-group`, `min-width`), yani
// bant hiçbir ekranda boşalmaz.
const GROUPS = [0, 1];
const REPEATS = [0, 1, 2, 3, 4, 5, 6, 7];

const AnnouncementMarquee = ({ text }) => {
  if (!text) return null;
  return (
    <div className="announcement-content">
      {GROUPS.map((group) => (
        <div className="announcement-group" key={group}>
          {REPEATS.map((item) => (
            // Kopyalar görseldir; ekran okuyucu duyuruyu on altı kez
            // okumamalı, ilki yeter.
            <span
              key={item}
              className="announcement-item"
              aria-hidden={group === 0 && item === 0 ? undefined : 'true'}
            >
              <Megaphone size={12} />
              {text}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};

export default AnnouncementMarquee;
